import { Routes, Route, Navigate, useLocation } from "react-router-dom";
import { UserProvider, useUser } from "./Context/UserContext";
import { useEffect } from "react";
import Login from "./Components/Home/Login";
import Home from "./Components/Home";
import ProtectedRoutes from "./ProtectedRoutes";
import SpeciesStock from "./Components/SpeciesStock";
import Production from "./Components/Production/Production";
import Header from "./Components/Global/Header";
import Footer from "./Components/Global/Footer";
import RequestSampling from "./Components/Farmer/RequestSampling";
import Farmer from "./Components/Farmer/Farmer";
import Profile from "./Components/Global/Profile";
import SpeciesRequest from "./Components/SpeciesRequest";
import FarmerViewStatus from "./Components/Farmer/FarmerViewStatus";
import BillGenerate from "./Components/BillGenerate";
import SchemeManagement from "./Components/Production/Scheme";
import RequestSpecies from "./Components/Farmer/RequestSpecies";
import Target from "./Components/Target/Target";
import EditInfo from "./Components/EditInfo/EditInfo";
import BlockReport from "./Components/Reports/Blockreport";
import ProductionCenterReport from "./Components/Reports/ProductionCenterReport";
import DistrictReport from "./Components/Reports/DistrictReport";
import OfficerRegister from "./Components/Officer/OfficerRegistration";
import HomeDashboard from "./Components/Dashboard/HomeDashboard";
import Headers from "./Components/Home/Header";
import Footers from "./Components/Home/Footer";
import DistrictsaplingReport from "./Components/Reports/DistrictsaplingReport";
import BlocksaplingReport from "./Components/Reports/BlocksaplingReport";
import Scheme from "./Components/Home/Scheme";
import Contact from "./Components/Home/Contact";
import ProductioncentersaplingReport from "./Components/Reports/ProductioncentersaplingReport";
import About from "./Components/Home/About";
import HomePage from "./Components/Home/HomePage";
import Inspection from "./Components/Production/Inspection";
import ProductionCenterScheme from "./Components/Production/ProductionCenterScheme";
import AssignSchemes from "./Components/Officer/AssignSchemes";

// <--- NEW: Import the new component here
import SuperControl from "./Components/DynamicControll/SuperControl";
import DepartmentReport from "./Components/Reports/DepartmentReport";

const DashboardLayout = ({ children }) => {
  const { logout } = useUser();

  const handleLogout = () => {
    logout();
    window.location.href = "/Home";
  };

  return (
    <>
      <Header onLogout={handleLogout} />
      <main>{children}</main>
    </>
  );
};

const DashboardLayoutBeforeLogin = ({ children }) => {
  return (
    <>
      <Headers />
      <main>{children}</main>
      <Footers />
    </>
  );
};

const AppRoutesContent = () => {
  const { loading } = useUser();
  const location = useLocation();

  useEffect(() => {
    const isRequestFlow =
      location.pathname.startsWith("/request-sampling") ||
      location.pathname.startsWith("/request-species");

    if (!isRequestFlow) {
      sessionStorage.removeItem("activeFarmerId");
      sessionStorage.removeItem("farmerData");
    }
  }, [location.pathname]);

  if (loading) {
    return (
      <div style={{ textAlign: "center", padding: "50px" }}>Loading...</div>
    );
  }

  return (
    <Routes>
      <Route
        path="/login"
        element={
          <DashboardLayoutBeforeLogin>
            <Login />
          </DashboardLayoutBeforeLogin>
        }
      />
      <Route
        path="/about"
        element={
          <DashboardLayoutBeforeLogin>
            <About />
          </DashboardLayoutBeforeLogin>
        }
      />
      <Route
        path="/Home"
        element={
          <DashboardLayoutBeforeLogin>
            <HomePage />
          </DashboardLayoutBeforeLogin>
        }
      />
      <Route
        path="/schemes"
        element={
          <DashboardLayoutBeforeLogin>
            <Scheme />
          </DashboardLayoutBeforeLogin>
        }
      />
      <Route
        path="/contact"
        element={
          <DashboardLayoutBeforeLogin>
            <Contact />
          </DashboardLayoutBeforeLogin>
        }
      />
      <Route path="/login" element={<Login />} />

      <Route
        path="/edit-info"
        element={
          <ProtectedRoutes>
            <DashboardLayout>
              <EditInfo />
            </DashboardLayout>
          </ProtectedRoutes>
        }
      />

      <Route
        path="/"
        element={
          <ProtectedRoutes>
            <DashboardLayout>
              <Home />
            </DashboardLayout>
          </ProtectedRoutes>
        }
      />
      <Route
        path="/test"
        element={
          <ProtectedRoutes>
            <DashboardLayout>
              <HomeDashboard />
            </DashboardLayout>
          </ProtectedRoutes>
        }
      />
      <Route
        path="/production"
        element={
          <ProtectedRoutes>
            <DashboardLayout>
              <Production />
            </DashboardLayout>
          </ProtectedRoutes>
        }
      />
      <Route
        path="/scheme"
        element={
          <ProtectedRoutes>
            <DashboardLayout>
              <SchemeManagement />
            </DashboardLayout>
          </ProtectedRoutes>
        }
      />
      <Route
        path="/species"
        element={
          <ProtectedRoutes>
            <DashboardLayout>
              <SpeciesStock />
            </DashboardLayout>
          </ProtectedRoutes>
        }
      />
      <Route
        path="/status"
        element={
          <ProtectedRoutes>
            <DashboardLayout>
              <FarmerViewStatus />
            </DashboardLayout>
          </ProtectedRoutes>
        }
      />
      <Route
        path="/allocations"
        element={
          <ProtectedRoutes>
            <DashboardLayout>
              <SpeciesRequest />
            </DashboardLayout>
          </ProtectedRoutes>
        }
      />
      <Route
        path="/bill"
        element={
          <ProtectedRoutes>
            <DashboardLayout>
              <BillGenerate />
            </DashboardLayout>
          </ProtectedRoutes>
        }
      />
      <Route
        path="/districtreport"
        element={
          <ProtectedRoutes>
            <DashboardLayout>
              <DistrictReport />
            </DashboardLayout>
          </ProtectedRoutes>
        }
      />
      <Route
        path="/farmer"
        element={
          <ProtectedRoutes>
            <DashboardLayout>
              <Farmer />
            </DashboardLayout>
          </ProtectedRoutes>
        }
      />
      <Route
        path="/request-sapling"
        element={
          <ProtectedRoutes>
            <DashboardLayout>
              <RequestSampling />
            </DashboardLayout>
          </ProtectedRoutes>
        }
      />
      <Route
        path="/request-species/:centerId/:farmerId"
        element={
          <ProtectedRoutes>
            <DashboardLayout>
              <RequestSpecies />
            </DashboardLayout>
          </ProtectedRoutes>
        }
      />
      <Route
        path="/target"
        element={
          <ProtectedRoutes>
            <DashboardLayout>
              <Target />
            </DashboardLayout>
          </ProtectedRoutes>
        }
      />
      {/*  */}
      {/* <Route
        path="/district/:id/BlockReport"
        element={
          <ProtectedRoutes>
            <DashboardLayout>
              <BlockReport />
            </DashboardLayout>
          </ProtectedRoutes>
        }
      />
      <Route
        path="/block/:id/centers"
        element={
          <ProtectedRoutes>
            <DashboardLayout>
              <ProductionCenterReport />
            </DashboardLayout>
          </ProtectedRoutes>
        }
      /> */}
      <Route
        path="/department-report"
        element={
          <ProtectedRoutes>
            <DashboardLayout>
              <DepartmentReport />
            </DashboardLayout>
          </ProtectedRoutes>
        }
      />

      {/* 2. District Report (Child of Department) */}
      <Route
        path="/department/:id/DistrictReport"
        element={
          <ProtectedRoutes>
            <DashboardLayout>
              <DistrictReport />
            </DashboardLayout>
          </ProtectedRoutes>
        }
      />

      {/* 3. Block Report (Child of District) */}
      <Route
        path="/district/:id/BlockReport"
        element={
          <ProtectedRoutes>
            <DashboardLayout>
              <BlockReport />
            </DashboardLayout>
          </ProtectedRoutes>
        }
      />

      {/* 4. Production Center Report (Child of Block) */}
      <Route
        path="/block/:id/centers"
        element={
          <ProtectedRoutes>
            <DashboardLayout>
              <ProductionCenterReport />
            </DashboardLayout>
          </ProtectedRoutes>
        }
      />

      {/* district report */}
      <Route
        path="/DistrictsaplingReport"
        element={
          <ProtectedRoutes>
            <DashboardLayout>
              <DistrictsaplingReport />
            </DashboardLayout>
          </ProtectedRoutes>
        }
      />
      <Route
        path="/district/:id/BlockSaplingReport"
        element={
          <ProtectedRoutes>
            <DashboardLayout>
              <BlocksaplingReport />
            </DashboardLayout>
          </ProtectedRoutes>
        }
      />
      <Route
        path="/block/:id/CenterSaplingReport"
        element={
          <ProtectedRoutes>
            <DashboardLayout>
              <ProductioncentersaplingReport />
            </DashboardLayout>
          </ProtectedRoutes>
        }
      />
      <Route
        path="/profile"
        element={
          <ProtectedRoutes>
            <DashboardLayout>
              <Profile />
            </DashboardLayout>
          </ProtectedRoutes>
        }
      />
      <Route
        path="/officer-registartion"
        element={
          <ProtectedRoutes>
            <DashboardLayout>
              <OfficerRegister />
            </DashboardLayout>
          </ProtectedRoutes>
        }
      />
      <Route
        path="/inspection"
        element={
          <ProtectedRoutes>
            <DashboardLayout>
              <Inspection />
            </DashboardLayout>
          </ProtectedRoutes>
        }
      />
      <Route
        path="/ProductionCenterScheme"
        element={
          <ProtectedRoutes>
            <DashboardLayout>
              <ProductionCenterScheme />
            </DashboardLayout>
          </ProtectedRoutes>
        }
      />

      <Route
        path="/assign-schemes"
        element={
          <ProtectedRoutes>
            <DashboardLayout>
              <AssignSchemes />
            </DashboardLayout>
          </ProtectedRoutes>
        }
      />

      {/* <--- NEW: Add the Route for the Super Admin Page here */}
      <Route
        path="/super-control"
        element={
          <ProtectedRoutes>
            <DashboardLayout>
              <SuperControl />
            </DashboardLayout>
          </ProtectedRoutes>
        }
      />

      {/* I cleaned up the duplicate routes below for clarity, but kept the structure if you need them */}
      <Route path="*" element={<Navigate to="/Home" replace />} />
    </Routes>
  );
};

const AppRoutes = () => {
  return (
    <UserProvider>
      <AppRoutesContent />
    </UserProvider>
  );
};

export default AppRoutes;
